export default class TradeAgreement {

    constructor(
        public incentiveSchemeName: string,
        public body: string) {

        }
}